import { render, staticRenderFns } from "./gzzoc-elderly-cataract.vue?vue&type=template&id=6cef282b&scoped=true&lang=pug&"
import script from "./gzzoc-elderly-cataract.vue?vue&type=script&lang=js&"
export * from "./gzzoc-elderly-cataract.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-elderly-cataract.vue?vue&type=style&index=0&id=6cef282b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef282b",
  null
  
)

export default component.exports